import { useEffect, useState } from 'react'

import { AppListMenu } from './AppListMenu'
import { Image } from '@fluentui/react'
import Link from 'next/link'
import { commonShared } from 'com-ui/utilities/imagePath'
import { getPortalApp } from '../utilities/getPortalApp'
import { motion } from 'framer-motion'
import styled from 'styled-components'
import { useRouter } from 'next/router'
import { useSidebarContext } from 'com-ui2/layouts/useSellessLayout'

interface ILogoProps {
  linkHref?: string
}

interface ILogoImageProps {
  text?: string
  collapsed?: boolean
}

const buildVersion = process.env.buildVersion

export const Logo = (props: ILogoProps) => {
  const router = useRouter()
  const { sidebarState, sidebarConfig } = useSidebarContext()
  const { collapseStyle } = sidebarConfig
  const { collapsed } = sidebarState
  const appList = getPortalApp()
  const startMenuList = [...appList]
  const [appText, setAppText] = useState('')

  useEffect(() => {
    if (router.pathname) {
      const text = appList.find((item) => router.pathname.includes(item.link))?.name
      setAppText(text || 'stream')
    }
  }, [router])

  return (
    <LogoContainer className={`justify-center ${collapseStyle}${collapsed ? ' collapsed' : ' '}`} layout>
      {/* {startMenuList?.length && (
        <div className="mr-3">
          <AppListMenu />
        </div>
      )} */}
      {props.linkHref ? (
        <Link href={`${props.linkHref ?? ''}`} passHref>
          <a>
            <LogoImage text={appText} collapsed={collapsed ?? false} />
          </a>
        </Link>
      ) : (
        <LogoImage text={appText} />
      )}
    </LogoContainer>
  )
}

const LogoImage = (props: ILogoImageProps) => (
  <LogoImageContainer className={`${props.collapsed ? 'collapsed' : ''}`}>
    {props.collapsed ? (
      <Image src={commonShared('selless-logo-short.svg')} alt="Selless logo" />
    ) : props.text ? (
      <>
        <img className="logo-app" src={commonShared('selless-logo-app.svg')} alt="Selless logo" />
        <span className="app-text">{props.text}</span>
        <span className="versioning">{buildVersion ?? 'v1.0.0'}</span>
      </>
    ) : (
      <>
        <img className="logo-app" src={commonShared('selless-logo-black.svg')} alt="Selless logo" />
        <span className="versioning empty-app-text">{buildVersion ?? 'v1.0.0'}</span>
      </>
    )}
  </LogoImageContainer>
)

const LogoImageContainer = styled.div`
  position: relative;
  display: flex;

  .app-text {
    position: absolute;
    bottom: 0;
    left: 51px;
    color: #A3A8AF;
    font-size: 12px;
    line-height: 0px;
    white-space: nowrap;
  }

  .logo-app {
    width: 124px;
    height: 40px;
  }

  .versioning {
    background-color: var(--indigo-2);
    border-radius: 12px;
    color: var(--gray-5);
    padding: 0 8px;
    line-height: 20px;
    font-size: 11px;
    margin-left: 8px;
    align-self: flex-start;
    top: 3px;
    position: relative;

    &.empty-app-text {
      top: 10px;
    }
  }
`

const LogoContainer = styled(motion.div)`
  border-bottom: 1px solid var(--indigo-3);
  padding: 16px 24px;
  position: relative;
  display: flex;
  align-items: center;

  button {
    height: auto;
    padding: 0;
  }

  &.collapsed {
    &.compact {
      opacity: 0;
    }

    border-bottom: 0;
    flex-direction: column;
    padding-top: 24px;
    padding-bottom: 8px;

    button {
      margin: 0 auto;
    }

    a {
      margin-top: 32px;
    }
  }
`
